var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "space-between" } },
      [
        _c("div", [_vm._v("Other Charge")]),
        this.isEdit
          ? _c(
              "div",
              {
                staticClass: "triggers",
                staticStyle: { display: "flex", "justify-content": "flex-end" }
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "1", type: "primary" },
                    on: { click: _vm.addChargeHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "2", type: "primary" },
                    on: { click: _vm.delChargeHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                )
              ],
              1
            )
          : _vm._e()
      ]
    ),
    _c(
      "div",
      [
        _c("cargo-ag-grid", {
          staticStyle: { height: "100%" },
          attrs: {
            "grid-options": _vm.gridOptions,
            "column-defs": _vm.columnDefs,
            "show-side-bar": false,
            "row-data": _vm.rowData
          },
          on: {
            gridReady: function(params) {
              _vm.gridApi = params.api
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }